import type { BadgeTone } from '@/shared/ui';
import type { FollowupState, SlaState, Urgency } from '@contracts/procurement';

/** Etiquetas y tonos de los enums del dominio. Una sola fuente para la UI. */

export const STATE_LABEL: Record<FollowupState, string> = {
  nueva: 'Nueva',
  autorizada: 'Autorizada',
  en_compra: 'En compra',
  rechazada: 'Rechazada',
  cerrada: 'Cerrada',
  cancelada: 'Cancelada',
};

export const STATE_TONE: Record<FollowupState, BadgeTone> = {
  nueva: 'info',
  autorizada: 'success',
  en_compra: 'neutral',
  rechazada: 'danger',
  cerrada: 'success',
  cancelada: 'danger',
};

export const SLA_LABEL: Record<SlaState, string> = {
  on_track: 'En tiempo',
  due_soon: 'Próxima a vencer',
  overdue: 'Vencida',
};

export const SLA_TONE: Record<SlaState, BadgeTone> = {
  on_track: 'success',
  due_soon: 'warning',
  overdue: 'danger',
};

export const URGENCY_LABEL: Record<Urgency, string> = {
  normal: 'Normal',
  urgent: 'Urgente',
};
